(ns frontend.dom-utils)

(defn is-ancestor? [node ancestor]
  (when node
    (let [parent (-> node .-parentElement)]
      (if (or (nil? parent) (= parent node))
        false                                               ;; false - we reached document root
        (or (= parent ancestor)                             ;; true
            (is-ancestor? parent ancestor))))))             ;; recursion

(defn find-parent-with-class [node cls]
  (when node
    (let [parent (-> node .-parentElement)
          has-class? (some-> parent
                             .-classList
                             (.contains cls))]
      (if (or (nil? parent) has-class?)
        parent
        (find-parent-with-class parent cls)))))
